module.exports = __webpack_public_path__ + "static/media/icita2021.16f29f59.PNG";